import { CurrencyCode } from '@omnea-app/packages/universal/currency-utils/getCurrencyCodes'
import { PaymentIntervalEnum } from '@omnea-app/packages/universal/hasura/graphql'
import { Price } from '@omnea-app/packages/universal/price/price'

// Widened from the strict domain shape so both the backend domain Agreement and the type
// the frontend gets from the API satisfy it (they encode these fields as enum vs string union).
// The casts back to the strict types below are safe — same runtime values.
export type SpendTerm = {
  spend: ReadonlyArray<{
    rate: number
    frequency: string
    fxRate: number
    currencyCode: CurrencyCode
  }>
}

export const agreementTermToPrices = (term: SpendTerm, termIndex?: number): Price[] =>
  term.spend.reduce((acc, spendItem) => {
    const itemWithSameFrequency = acc.find(
      (existingItem) => existingItem.termIndex === termIndex && existingItem.paymentInterval === spendItem.frequency
    )
    if (itemWithSameFrequency) {
      itemWithSameFrequency.amount += spendItem.rate
    } else {
      acc.push({
        amount: spendItem.rate,
        paymentInterval: spendItem.frequency as PaymentIntervalEnum,
        fxRate: spendItem.fxRate,
        currency: spendItem.currencyCode,
        termIndex,
      })
    }
    return acc
  }, [] as Price[])
